import {usePumps} from './usePumps'
import {useUnloadingMethods} from './useUnloadingMethods'

/**
 * Main hook that coordinates unloading methods and pumps
 * Maintains backward compatibility with existing API
 */
export const useUnloadingMethod = () => {
  // Get unloading methods first as pumps depend on available methods
  const unloadingMethods = useUnloadingMethods()

  // Pass available methods to pumps hook for dependency coordination
  const pumps = usePumps(unloadingMethods.availableUnloadingMethods)

  // Return combined API
  return {
    // Unloading methods
    selectedUnloadingMethod: unloadingMethods.selectedUnloadingMethod,
    defaultUnloadingMethod: unloadingMethods.defaultUnloadingMethod,
    availableUnloadingMethods: unloadingMethods.availableUnloadingMethods,
    setUnloadingMethodCode: unloadingMethods.setUnloadingMethodCode,

    // Pumps
    selectedPump: pumps.selectedPump,
    availablePumpTypes: pumps.availablePumpTypes,
    setPumpType: pumps.setPumpType,
    setPumpSettings: pumps.setPumpSettings,
    setPumpDischarge: pumps.setPumpDischarge,

    // Configuration
    configuration: {
      unloadingMethod: unloadingMethods.configuration,
      pump: pumps.configuration
    }
  }
}
